export const fieldValidations = {
  account: {
    required: true,
  },
  idProduct: {
    required: true,
  },
  quantity: {
    required: true,
  },
  idCycleType: {
    required: true,
  },
  description: {
    required: true,
  },
  schedule: {
    required: true,
  },
  date: {
    required: false,
  },
};
